export function personName(row: { firstName: string; lastName: string }) {
    return `${row.firstName} ${row.lastName}`.trim();
}
